// src/routes/inventoryRoutes.tsx
import { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';

// Lazy Inventory pages
const ProductsPage = lazy(() => import('../modules/inventory/ProductsPage'));
const WarehousesPage = lazy(() => import('../modules/inventory/WarehousesPage'));
const StockLevelsPage = lazy(() => import('../modules/inventory/StockLevelsPage'));
const StockMovementsPage = lazy(() => import('../modules/inventory/StockMovementsPage'));

const Fallback = <div style={{ padding: 16 }}>Loading Inventory…</div>;

const withSuspense = (el: JSX.Element) => <Suspense fallback={Fallback}>{el}</Suspense>;

export function renderInventoryRoutes(
  Protected: ({ children }: { children: JSX.Element }) => JSX.Element
): JSX.Element {
  return (
    <>
      <Route path="/inventory/products" element={withSuspense(<Protected><ProductsPage /></Protected>)} />
      <Route path="/inventory/warehouses" element={withSuspense(<Protected><WarehousesPage /></Protected>)} />
      <Route path="/inventory/stock-levels" element={withSuspense(<Protected><StockLevelsPage /></Protected>)} />
      <Route path="/inventory/stock-movements" element={withSuspense(<Protected><StockMovementsPage /></Protected>)} />
    </>
  );
}

